import { DrupalNodeBasicPage, DrupalNodeRelease } from "@/types"
import { Faq } from "../widget/Faq.client"
import { Body } from "../wysiwyg/Body"

export const RelatedFAQ = async ({resource}: {
  resource: DrupalNodeBasicPage | DrupalNodeRelease
}) => {

  if (resource.type == "node--release") {
    return <></>
  }

  const articles = resource.field_related_faqs

  if (!articles) {
    return <></>
  }

  if (articles.length == 0) {
    return <></>
  }

  return <>
    <h2 id="related-faq" className="my-4 font-medium text-lg">Frequently asked questions</h2>
    <Faq className="mb-8" faqs={
      articles.map(article => { return {
        question: article.title,
        answer: <Body value={article.body?.processed ?? article.body?.value ?? null} />
      }})
    } />
  </>
}